import { Link } from 'react-router';
import { ArrowRight } from 'lucide-react';
import type { Product } from '@/api/products';
import { formatForint } from '@/lib/utils';
import { ProductImage } from './ProductImage';

export const ProductCard = ({ product }: { product: Product }) => (
  <li className="flex flex-col overflow-hidden rounded-xl border-2 border-line bg-paper">
    <div className="aspect-[4/3] w-full overflow-hidden">
      <ProductImage src={product.imageUrl} alt={product.name} />
    </div>

    <div className="flex flex-1 flex-col gap-3 p-6">
      <div>
        <h3 className="text-lg">{product.name}</h3>
        {product.shortDescription && <p className="mt-1 text-sm text-teal-ink">{product.shortDescription}</p>}
      </div>

      <p className="mt-auto">
        <span className="font-display text-xl font-bold text-navy">{formatForint(product.monthlyPrice)}</span>
        <span className="ml-1 text-sm text-ink-soft">/ hó</span>
      </p>

      <Link
        to={`/termekek/${product.slug}`}
        className="inline-flex min-h-12 items-center justify-center gap-2 rounded-md border-2 border-navy px-5 font-semibold text-navy no-underline hover:bg-navy hover:text-cream"
      >
        Részletek
        <ArrowRight className="size-5" aria-hidden="true" />
      </Link>
    </div>
  </li>
);
